import React, { useState, useEffect } from "react";
import Modal from '@mui/material/Modal';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import EditGoodsModal from './edit-goods-modal';
import AddGoodsModal from './add-goods-modal';
import Button from '@mui/material/Button';
import Paper from '@mui/material/Paper';
import TableContainer from '@mui/material/TableContainer';
import TablePagination from '@mui/material/TablePagination';
import CircularProgress from '@mui/material/CircularProgress';

export default function GoodsList() {

    const [allGoods, setAllGoods] = useState([]);
    const [loading, setLoading] = useState(true);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(25);
    const [open, setOpen] = React.useState(false);
    const [addGoodsOpen, setAddGoodsOpen] = React.useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);
    const handleAddGoodsOpen = () => setAddGoodsOpen(true);
    const handleAddGoodsClose = () => setAddGoodsOpen(false);
    const api_url = process.env.REACT_APP_API_URL;
    const [editedGoodsId, setEditedGoodsId] = useState("");

    useEffect(() => {
        async function getAllGoodsList() {
          const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': localStorage.getItem('token') },
            body: JSON.stringify({ complex_name: 'Охта' })
          };
          setLoading(true);
          try {
            const allGoods = await (await fetch(api_url+"/api/allGoods", requestOptions)).json();
            setAllGoods(allGoods.map(({ goods_id, goods_category, goods_name, price, salary, price_category }) => ({goodsId: goods_id, goodsCategory: goods_category, goodsName: goods_name, price: price, priceCategory: price_category, salary: salary })));
          } finally {
            setLoading(false);
          }
        }
        getAllGoodsList();
  
    }, [open, addGoodsOpen]);

    function showModal(goods_id){
        handleOpen();
        setEditedGoodsId(goods_id);
    }

    function showAddGoodsModal(){
        handleAddGoodsOpen();
    }

    return (
        <div>
            <button className='add-visit-button' onClick={() => showAddGoodsModal()}>
                <a>Добавить товар</a>
            </button>
            <TableContainer component={Paper} sx={{ maxHeight: 640 }}>
            <Table stickyHeader aria-label="goods table">
            <TableHead>
                <TableRow>
                    <TableCell>Категория</TableCell>
                    <TableCell>Наименование</TableCell>
                    <TableCell>Филиал</TableCell>
                    <TableCell align="right">Стоимость</TableCell>
                    <TableCell align="right">ЗП</TableCell>
                    <TableCell></TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
                {loading ? (
                    <TableRow><TableCell colSpan={6} align="center" sx={{ py: 6 }}><CircularProgress size={28} /></TableCell></TableRow>
                ) : allGoods.length === 0 ? (
                    <TableRow><TableCell colSpan={6} align="center" sx={{ py: 6, color: 'text.secondary' }}>Нет товаров</TableCell></TableRow>
                ) : allGoods.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map(({ goodsId, goodsCategory, goodsName, price, salary, priceCategory }) => (
                <TableRow key={goodsId} hover>
                    <TableCell>{goodsCategory}</TableCell>
                    <TableCell>{goodsName}</TableCell>
                    { priceCategory == "ohta_only" && <TableCell>Охта</TableCell>}
                    { priceCategory == "other" && <TableCell>Кудрово</TableCell>}
                    { priceCategory == "all" && <TableCell>Все филиалы</TableCell>}
                    <TableCell align="right">{price}</TableCell>
                    <TableCell align="right">{salary}</TableCell>
                    <TableCell>
                    <Button
                        variant="outlined"
                        onClick={() => showModal(goodsId)}>Изменить</Button>
                    </TableCell>
                </TableRow>
                ))}
            </TableBody>
            </Table>
            </TableContainer>
            {!loading && allGoods.length > 0 && (
            <TablePagination
                component="div"
                count={allGoods.length}
                page={page}
                onPageChange={(e, p) => setPage(p)}
                rowsPerPage={rowsPerPage}
                onRowsPerPageChange={(e) => { setRowsPerPage(parseInt(e.target.value, 10)); setPage(0); }}
                rowsPerPageOptions={[10, 25, 50, 100]}
                labelRowsPerPage="Строк на странице:"
            />
            )}
            <Modal
            open={open}
            onClose={handleClose}
            >
            <EditGoodsModal editedGoodsId={editedGoodsId}/>
            </Modal>

            <Modal
            open={addGoodsOpen}
            onClose={handleAddGoodsClose}
            >
            <AddGoodsModal />
            </Modal>
        </div>
    )
}

